module.exports = __webpack_public_path__ + "static/media/Item_Weapon_Lynx6_C.fa8c5333.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Main/Item_Weapon_Lynx6_C.png
// module id = 398
// module chunks = 0